import http from '@/utils/http';

const baseUrl = '/rastreabilidade/historico-raizen';

export default {

    historicoNotaFiscal(id) {
        let url =
            baseUrl + '/nota-fiscal' + '?id=' + id;

        return http.get({
            url: url,
            lockScreen: true,
            lockMessage: 'Buscando Histórico por Nota Fiscal'
        });
    }

};
